import { useEffect, useState } from 'react';

type ReleaseInfo = {
  release?: string;
};

export const useReleaseIdentifier = () => {
  const [release, setRelease] = useState<string | null>(null);

  useEffect(() => {
    fetch('/release-info.json')
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        // throw new Error('Failed to fetch release info');
      })
      .then(data => setRelease((data as ReleaseInfo | undefined)?.release ?? null))
      .catch(() => undefined);
  }, []);

  return { release };
};
